import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./planning.module.css";
import About3 from "Assets/taxplanning/taxplanning_2.png";
import Image1 from "Assets/taxplanning/taxplanning_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";

function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Amendment Tax Returns</h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <p>
                            Filing an amended tax return is necessary in certain
                            situations when a taxpayer discovers that there were
                            errors or omissions in their original tax return.
                            Here are some common reasons why someone should file
                            an amended tax return:
                            <br />
                            <br />
                            Tax Planning is critical to a healthy financial
                            life. Certain tax impacts and substantial tax
                            considerations are important and we can help protect
                            the assets you transfer from excessive depletion by
                            understanding these taxes and the various strategies
                            to help you minimize them.
                            <br />
                            <br />
                            Your tax return will be checked and rechecked by our
                            computer software identifying potential problems the
                            IRS may look at more closely and reviewing the math
                            to limit IRS contacts..
                        </p>
                        <h3>1. Correcting Errors or Omissions</h3>
                        <ul>
                            <li>
                                Missed Income: If a taxpayer forgot to report
                                some income, such as a freelance paycheck or
                                bank interest.
                            </li>
                            <li>
                                Incorrect Deductions or Credits: If a taxpayer
                                missed claiming a deduction or tax credit they
                                were eligible for, such as the Earned Income Tax
                                Credit or Child Tax Credit.
                            </li>
                            <li>
                                Incorrect Filing Status: If a taxpayer filed
                                under the wrong status (e.g., Single instead of
                                Married Filing Jointly).
                            </li>
                            <li>
                                Incorrect Dependents: If the taxpayer
                                incorrectly listed dependents or omitted them.
                            </li>
                            <li>
                                Mistakes in Tax Withholding or Estimated
                                Payments: If incorrect figures were reported for
                                tax withholding or estimated tax payments.
                            </li>
                        </ul>
                        <h3>2. Changes in Tax Laws</h3>
                        <ul>
                            <li>
                                Revisions to Tax Laws: If there are changes in
                                tax laws after the original return is filed that
                                may affect the taxpayer’s refund or liability
                                (e.g., new deductions or credits).
                            </li>
                        </ul>
                        <h3>3. Correcting Errors in Forms</h3>
                        <ul>
                            <li>
                                If an incorrect form was filed, or there was a
                                mistake in any supporting documents (like W2s,
                                1099s, etc.), an amended return may be needed to
                                correct the issue
                            </li>
                        </ul>
                        <h3>4. Impact of IRS Notices</h3>
                        <ul>
                            <li>
                                If the IRS sends a notice after filing the
                                original return indicating discrepancies, such
                                as a mismatch in income or credits, the taxpayer
                                may need to file an amended return to address
                                the issue.
                            </li>
                        </ul>
                        <h3>5. Claiming Additional Refunds</h3>
                        <ul>
                            <li>
                                If the taxpayer realizes that they overpaid
                                taxes or didn’t claim certain
                                deductions/credits, filing an amended return
                                allows them to claim a refund they may be
                                entitled to
                            </li>
                        </ul>

                        <h3>6. Adjustments for State and Local Taxes</h3>
                        <ul>
                            <li>
                                If there was an error in the state or local tax
                                return that needs correcting, an amended federal
                                tax return may also be necessary
                            </li>
                        </ul>
                    </div>
                    {/* <img src={Image1} alt="user" /> */}
                </div>
            </div>
        </Layout>
    );
}

export default About;
